<a
  [routerLink]="{ cxRoute: 'orderDetails', params: { code: property } } | cxUrl"
  [tabIndex]="tabIndex"
  class="eb-order-history-table-link"
>
  {{ property }}
</a>
